import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ParticipantChangesQueryVariables = {};


export type ParticipantChangesQuery = (
  { __typename?: 'Query' }
  & { provingGrounds: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | 'title' | 'abbr'>
  )>, participantChanges: Array<(
    { __typename?: 'ParticipantChange' }
    & Pick<Types.ParticipantChange, '_id' | 'type' | 'fullName' | 'department' | 'employeeId' | 'dateFrom' | 'dateTo' | 'oldDateFrom' | 'oldDateTo' | 'isSentToInvolvedPeople' | 'isSentToTaxOffice'>
    & { proving: (
      { __typename?: 'Proving' }
      & Pick<Types.Proving, '_id' | 'id' | 'title'>
      & { provingGround: Types.Maybe<(
        { __typename?: 'ProvingGround' }
        & Pick<Types.ProvingGround, '_id' | 'title' | 'abbr'>
      )>, responsible: Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'email'>
      )> }
    ), user: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'email'>
    ) | (
      { __typename?: 'Worker' }
      & Pick<Types.Worker, '_id' | 'email'>
    )> }
  )> }
);

export type TaxMailTemplatesQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type TaxMailTemplatesQuery = (
  { __typename?: 'Query' }
  & { mailTemplates: Array<(
    { __typename?: 'MailTemplate' }
    & Pick<Types.MailTemplate, '_id' | 'name' | 'provingGroundId' | 'subject' | 'to' | 'cc' | 'body' | 'type'>
  )> }
);

export type UpdateParticipantChangesMutationVariables = {
  updates: Array<Types.ParticipantChangeUpdate>
};


export type UpdateParticipantChangesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'updateParticipantChanges'>
);

export const ParticipantChangesDocument = gql`
    query ParticipantChanges {
  provingGrounds {
    _id
    title
    abbr
  }
  participantChanges {
    _id
    type
    proving {
      _id
      id
      title
      provingGround {
        _id
        title
        abbr
      }
      responsible {
        _id
        email
      }
    }
    user {
      _id
      email
    }
    fullName
    department
    employeeId
    dateFrom
    dateTo
    oldDateFrom
    oldDateTo
    isSentToInvolvedPeople
    isSentToTaxOffice
  }
}
    `;

    export function useParticipantChangesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ParticipantChangesQuery, ParticipantChangesQueryVariables>) {
      return ApolloReactHooks.useQuery<ParticipantChangesQuery, ParticipantChangesQueryVariables>(ParticipantChangesDocument, baseOptions);
    };
      export function useParticipantChangesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ParticipantChangesQuery, ParticipantChangesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ParticipantChangesQuery, ParticipantChangesQueryVariables>(ParticipantChangesDocument, baseOptions);
      };
      
export type ParticipantChangesQueryHookResult = ReturnType<typeof useParticipantChangesQuery>;
export type ParticipantChangesQueryResult = ApolloReactCommon.QueryResult<ParticipantChangesQuery, ParticipantChangesQueryVariables>;
export const TaxMailTemplatesDocument = gql`
    query TaxMailTemplates($provingGroundId: String) {
  mailTemplates(filter: {AND: [{OR: [{type: {EQ: taxRequirements}}, {type: {EQ: taxOfficeChanges}}]}, {provingGroundId: {EQ: $provingGroundId}}]}) {
    _id
    name
    provingGroundId
    subject
    to
    cc
    body
    type
  }
}
    `;

    export function useTaxMailTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaxMailTemplatesQuery, TaxMailTemplatesQueryVariables>) {
      return ApolloReactHooks.useQuery<TaxMailTemplatesQuery, TaxMailTemplatesQueryVariables>(TaxMailTemplatesDocument, baseOptions);
    };
      export function useTaxMailTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaxMailTemplatesQuery, TaxMailTemplatesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TaxMailTemplatesQuery, TaxMailTemplatesQueryVariables>(TaxMailTemplatesDocument, baseOptions);
      };
      
export type TaxMailTemplatesQueryHookResult = ReturnType<typeof useTaxMailTemplatesQuery>;
export type TaxMailTemplatesQueryResult = ApolloReactCommon.QueryResult<TaxMailTemplatesQuery, TaxMailTemplatesQueryVariables>;
export const UpdateParticipantChangesDocument = gql`
    mutation UpdateParticipantChanges($updates: [ParticipantChangeUpdate!]!) {
  updateParticipantChanges(updates: $updates)
}
    `;
export type UpdateParticipantChangesMutationFn = ApolloReactCommon.MutationFunction<UpdateParticipantChangesMutation, UpdateParticipantChangesMutationVariables>;

    export function useUpdateParticipantChangesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateParticipantChangesMutation, UpdateParticipantChangesMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateParticipantChangesMutation, UpdateParticipantChangesMutationVariables>(UpdateParticipantChangesDocument, baseOptions);
    };
export type UpdateParticipantChangesMutationHookResult = ReturnType<typeof useUpdateParticipantChangesMutation>;
export type UpdateParticipantChangesMutationResult = ApolloReactCommon.MutationResult<UpdateParticipantChangesMutation>;
export type UpdateParticipantChangesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateParticipantChangesMutation, UpdateParticipantChangesMutationVariables>;